<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import {useCategoryStore} from "@/stores/Grille/Category";
import {useSecurityStore} from "@/stores/Security";
import {computed, onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {total, loading} = useSharedData();
        const sheet = ref(true);
        const {getBack, priceFormat} = useSharedMethod();
        const {$router, $i18n} = useTools();
        
        const categoryStore = useCategoryStore();
        const securityStore = useSecurityStore();
        
        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.name"),
                align: "start",
                sortable: false,
                value: "name",
                width: "0%",
            },
            {
                text: $i18n.t("module.classe"),
                align: "start",
                sortable: false,
                value: "classeName",
                width: "0%",
            },
            {
                text: $i18n.t("common.periodicity"),
                align: "start",
                sortable: false,
                value: "periodicity",
                width: "0%",
            },
            {
                text: $i18n.t("category.value"),
                align: "start",
                sortable: false,
                value: "value",
            },
            {
                text: $i18n.t("common.percent"),
                align: "start",
                sortable: false,
                value: "percenatge",
            },
            {
                text: $i18n.t("category.base_salary"),
                align: "start",
                sortable: false,
                value: "baseSalary",
            },
        ]
        
        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_GRILLE'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'categories.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_GRILLE'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'categories.delete', params: {id: item.id}})
                },
            }
        ];
        
        function findAll() {
            loading.value = true;
            axios.get('/categories').then((response) => {
                total.value = response.data.length;
                categoryStore.setCategories(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }
        
        const sortedCategories = computed(() => {
            return categoryStore.categories.slice().sort((a, b) => {
                if (a.classId < b.classId) return -1;
                if (a.classId > b.classId) return 1;
                if (a.id < b.id) return -1;
                if (a.id > b.id) return 1;
                return 0;
            });
        });
        
        onMounted(() => findAll());
        
        function view(item) {
            $router.push({name: "categories.view", params: {id: item.id}});
        }
        
        return {
            categoryStore,
            securityStore,
            total,
            loading,
            sheet,
            sortedCategories,
            headers,
            actions,
            getBack,
            view,
            findAll,
            priceFormat
        };
    }
};
</script>

<template>
    <div>
        <v-bottom-sheet
            v-model="sheet"
            inset
            persistent
            scrollable
        >
            <v-card elevation="5">
                <w-app
                    :title="$t('module.categories')"
                    show-total
                    :total="total"
                >
                    <template v-slot:rightToolbar>
                        <w-btn-reload :loading="loading" @press="findAll"/>
                        <w-btn-add
                            :show="securityStore.authorities['UPDATE_GRILLE']"
                            @press="$router.push({ name: 'categories.add' })"
                        />
                        <w-btn-close @press="getBack"/>
                    </template>
                    
                    <template v-slot:content>
                        <w-data-table
                            :headers="headers"
                            :actions="actions"
                            :items="sortedCategories"
                            disable-pagination
                            fixed-header
                            height="600"
                            @rowDbClick="view"
                        >
                            <template v-slot:[`item.name`]="{ item }">
                                <w-inline-text bold :text="item.name"/>
                            </template>
                            <template v-slot:[`item.classeName`]="{ item }">
                                <w-inline-text :text="item.classeName"/>
                            </template>
                            <template v-slot:[`item.periodicity`]="{ item }">
                                <w-inline-text v-if="item.byRung" :text="item.periodicity"/>
                            </template>
                            <template v-slot:[`item.value`]="{ item }">
                                <w-inline-text
                                    v-if="item.byRung && item.byValue"
                                    :text="item.value"
                                />
                            </template>
                            <template v-slot:[`item.percenatge`]="{ item }">
                                <w-inline-text
                                    v-if="item.byRung && !item.byValue"
                                    :text="item.percenatge"
                                />
                            </template>
                            <template v-slot:[`item.baseSalary`]="{ item }">
                                <w-chip color="teal" :text="priceFormat(item.baseSalary)"/>
                            </template>
                        </w-data-table>
                    </template>
                </w-app>
            </v-card>
        </v-bottom-sheet>
        <router-view/>
    </div>
</template>
